import { render } from "./FormCreateOrUpdate.vue?vue&type=template&id=9dafff74&scoped=true"
import script from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"

import "./FormCreateOrUpdate.vue?vue&type=style&index=0&id=9dafff74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9dafff74"

export default script